module.exports = "https://static.wmbcdn.com/uniweb/images/95def3a040ce7e9d85c36e6d1d729de1.svg";